import React, { memo, useState } from "react";
import { Col, Row, Switch } from "antd";
import {
  DropDown,
  InputField,
  PhoneInput,
  SubmitButton,
  TextComponent,
} from "../../../components";
import styles from "./editVendors.module.css";
import addDoc from "../../../assets/staticImages/addDoc.png";
import addImg from "../../../assets/staticImages/addImg.png";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { RiDeleteBinLine } from "react-icons/ri";
import { useRef } from "react";
import Modal from "../../../components/modal/Modal";

const RenderDoc = memo(({ docs, i }) => {
  return (
    <DocViewer
      documents={[docs]}
      pluginRenderers={DocViewerRenderers}
      className={styles.pdfView}
      config={{
        header: { disableHeader: true },
        pdfVerticalScrollByDefault: false,
      }}
      language="en"
    />
  );
});

const RenderDocView = memo(({ docs, setDocs, i, doc }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  function handleDropdown(e) {
    e.stopPropagation();
    setDropdownOpen((prev) => !prev);
  }
  const deleteDoc = (id) => {
    console.log("iddddddddddddddddddd", id);
    const arr = docs.filter((data) => {
      console.log(id != data.id);
      if(id != data.id){
        return data
      }
      });
    setDocs(arr);
    setDropdownOpen(false);
  };

  return (
    <Col className={styles.pdfCol} key={docs[i].id.toString()}>
      <Row style={{ justifyContent: "flex-end" }}>
        <TextComponent textClass={styles.dropdownBtn} onClick={handleDropdown}>
          ...
        </TextComponent>
      </Row>
      {dropdownOpen && (
        <Row className={styles.dropdown}>
          <Col>
            <Row
              className={styles.dropdownItem}
              onClick={() => deleteDoc(docs[i].id)}
            >
              <RiDeleteBinLine fontSize="1.1rem" />
              <TextComponent textClass={styles.dropdownText}>
                Delete
              </TextComponent>
            </Row>
          </Col>
        </Row>
      )}
      <RenderDoc docs={doc} i={i} />
    </Col>
  );
});

function EditVendors() {
  const [DocUpload, setDocUpload] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [contact, setContact] = useState('');
  const [docs, setDocs] = useState([]);

  const docRef = useRef();
  const imgRef = useRef();

  const handleClick = () => {
    docRef.current.value = "";
    docRef.current.click();
  };
  const handleClickImg = () => {
    imgRef.current.value = "";
    imgRef.current.click();
  };
  return (
    <>
      <TextComponent text={"Personal Information"} textClass={styles.heading} />
      <Row className={styles.row}>
        <Col className={styles.col}>
          <InputField label="Name" placeholder={"Mary Freund"} />
          <InputField label="Email" placeholder={"email@bestdayever.com"} />
          <PhoneInput
            style={{ marginBottom: "20px", backgroundColor: "white" }}
            className={styles.phoneInput}
            value={contact}
            onChange={setContact}
            placeholder={"989-959595"}
            label={"Contact Number"}
          />
          <label className={styles.label} htmlFor="messageBox">
            About The Vendor
          </label>
          <textarea
            className={styles.textarea}
            placeholder="Enter Vendor Details Here"
            cols="30"
            rows="5"
          />
        </Col>
        <Col className={styles.col}>
          <DropDown
            placeholder={"Category"}
            name={"role"}
            label={"Category"}
            // onChange={handleChangeVendorType}
            contClass={styles.contClass}
            options={[
              { value: "Makeup Artist", option: "Makeup Artist" },
              { value: "Photographers", option: "Photographers" },
              { value: "Wedding DJs", option: "Wedding DJs" },
            ]}
          />
          <InputField label="Address" placeholder={"Fairfield - US"} />
          <InputField label="Services" placeholder={"Add Services"} />
        </Col>
      </Row>
      <div className={styles.heading}>
        <TextComponent
          textClass={styles.heading}
          text={"Do You Wan to Add Document"}
        />
        <Switch
          checked={DocUpload}
          onChange={setDocUpload}
          className={styles.swithClass}
          style={{
            backgroundColor: DocUpload && "var(--primary-color)",
          }}
        />
      </div>
      {DocUpload && (
        <>
          <Row>
            {docs.map((doc, i) => {
              return (
                <>
                  <RenderDocView
                    docs={docs}
                    doc={doc}
                    i={i}
                    setDocs={setDocs}
                  />
                </>
              );
            })}
          </Row>
          <Row>
            <Col className={styles.imgCol} onClick={handleClick}>
              <img src={addDoc} className={styles.image} alt="docSelect" />
              <input
                type="file"
                accept=".pdf"
                multiple
                onChange={(el) =>
                  el.target.files?.length &&
                  setDocs([
                    ...docs,
                    ...Array.from(el.target.files).map((file, i) => ({
                      uri: window.URL.createObjectURL(file),
                      fileName: file.name,
                      id: `${docs?.length + i + 12}`,
                    })),
                  ])
                }
                ref={docRef}
                className={styles.displayNone}
              />
            </Col>
            <Col className={styles.imgCol} onClick={handleClickImg}>
              <img src={addImg} className={styles.image} alt="docSelect" />
              <input
                type="file"
                accept=".jpg,.png,.gif,.jpeg"
                multiple
                onChange={(el) =>
                  el.target.files?.length &&
                  setDocs([
                    ...docs,
                    ...Array.from(el.target.files).map((file, i) => ({
                      uri: window.URL.createObjectURL(file),
                      fileName: file.name,
                      id: `${docs.length + i + 12}`,
                    })),
                  ])
                }
                ref={imgRef}
                className={styles.displayNone}
              />
            </Col>
          </Row>
        </>
      )}
      <SubmitButton
        title="Save"
        btnClass={styles.btnSubmit}
        onClick={() => setIsModalOpen(true)}
      />
      <Modal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        closable={true}
        pinkBg={true}
      >
        <Row className={styles.modalContent}>
          {/* <MdDelete className={styles.deleteIcon} /> */}
          <svg
            className={styles.deleteIcon}
            viewBox="0 0 286 304"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M98.8389 303.515H98.8374C69.7803 303.518 40.7211 303.521 11.6679 303.512C1.12824 303.512 0.384886 302.756 0.384886 292.127C0.381393 287.063 0.373303 282 0.365214 276.937C0.342563 262.759 0.319913 248.582 0.39816 234.404C0.570724 205.051 20.2563 185.373 49.5789 185.174C56.0117 185.131 62.4445 185.142 68.8773 185.153C74.3913 185.162 79.9052 185.171 85.4192 185.147C94.4589 185.107 97.6181 181.869 97.6845 172.687C97.7258 167.01 97.7109 161.334 97.696 155.657C97.6917 154.036 97.6874 152.414 97.6845 150.792C97.6845 150.461 97.7073 150.121 97.7302 149.78C97.7834 148.989 97.8369 148.193 97.6049 147.488C96.3919 143.769 95.2632 140.011 94.1344 136.252L94.1344 136.252L94.1343 136.252C91.4089 127.178 88.6829 118.102 84.7687 109.563C77.1892 93.0291 69.8884 76.5482 66.5035 58.6076C65.6539 54.1092 65.4283 49.3454 65.7867 44.7806C66.5566 34.9743 73.4459 28.4059 83.2555 28.4059C87.636 28.4059 90.543 26.9595 93.6492 24.1065C109.817 9.27103 129.622 2.35754 150.98 1.11019C165.067 0.294228 179.326 1.51703 193.457 2.72887C194.493 2.81774 195.529 2.90654 196.564 2.99448C205.046 3.72431 207.369 8.96583 207.356 17.339C207.342 23.7217 208.444 30.8077 211.364 36.3809C225.475 63.3449 222.01 88.2785 204.608 112.244C203.4 113.902 202.842 116.238 202.537 118.334C200.904 129.68 196.736 139.937 190.564 149.624C184.649 158.906 186.779 169.162 188.812 178.958C188.901 179.385 188.989 179.812 189.077 180.237C189.528 182.4 194.944 184.789 198.17 184.921C206.479 185.281 214.806 185.235 223.135 185.189H223.136C227.42 185.166 231.705 185.142 235.988 185.174C265.297 185.359 284.943 205.038 285.116 234.43C285.22 251.644 285.182 268.868 285.145 286.084V286.089V286.094V286.099C285.139 288.56 285.134 291.02 285.129 293.48C285.116 302.331 283.987 303.486 275.147 303.499C241.965 303.519 208.783 303.516 175.601 303.514C164.54 303.513 153.479 303.512 142.418 303.512C127.894 303.512 113.368 303.514 98.8418 303.515H98.8403H98.8389ZM191.254 95.8953C191.105 95.8768 190.957 95.8553 190.807 95.8337C190.635 95.8089 190.462 95.7839 190.285 95.7626C190.285 94.3107 190.279 92.8589 190.272 91.4074C190.258 88.2158 190.244 85.0261 190.298 81.8428C190.497 70.4441 184.896 64.2339 173.692 64.1676C154.232 64.0614 134.759 64.1676 115.299 64.3666C105.211 64.4728 100.114 70.2583 100.26 80.4096C100.321 84.8706 100.283 89.3316 100.246 93.7912V93.7918V93.7924V93.793C100.202 99.0168 100.158 104.239 100.273 109.457C100.379 114.287 100.764 119.21 101.879 123.881C106.737 144.104 123.423 159.829 141.091 161.275C162.502 163.026 181.537 149.146 187.577 125.938C189.334 119.271 189.873 112.289 190.413 105.308C190.656 102.161 190.899 99.0132 191.254 95.8953ZM110.749 165.25V165.25C110.812 167.222 110.862 168.8 110.627 170.338C109.698 176.323 112.021 180.025 117.304 183.011C124.392 187.018 131.135 191.676 137.746 196.439C141.264 198.987 143.905 199.385 147.595 196.612C151.922 193.368 156.484 190.426 161.043 187.485C162.974 186.24 164.905 184.995 166.816 183.727C175.856 177.743 175.856 177.743 173.666 166.304C152.268 178.446 131.587 177.066 110.68 161.753C110.68 163.062 110.716 164.211 110.749 165.25ZM271.908 290.561V249.903C254.16 254.494 236.32 274.969 236.174 290.561H271.908ZM13.4865 249.929V290.282H49.778C46.7914 272.09 30.6102 254.043 13.4865 249.929ZM139.097 219.497L139.096 219.498C136.388 222.319 134.028 224.777 131.839 227.384C130.711 228.725 129.649 230.901 129.901 232.48C130.611 237.006 131.605 241.484 132.603 245.978C132.986 247.703 133.369 249.43 133.737 251.164H153.489C153.822 249.607 154.162 248.069 154.5 246.544C155.425 242.361 156.329 238.271 157.02 234.139C157.272 232.652 156.701 230.569 155.719 229.441C152.941 226.258 150.008 223.215 146.796 219.883L146.79 219.878C145.492 218.531 144.148 217.137 142.75 215.667C141.46 217.036 140.247 218.299 139.097 219.497ZM131.773 207.719L128.596 205.634L128.592 205.632C120.992 200.645 113.265 195.575 105.742 190.627C102.7 192.448 99.8398 194.169 96.8819 195.948C95.5283 196.763 94.1543 197.589 92.7332 198.443C98.4173 206.188 104.092 213.932 109.833 221.766L113.454 226.708C119.68 220.258 125.454 214.274 131.773 207.719ZM171.993 226.827C178.962 217.313 185.798 207.984 192.635 198.656C189.801 196.978 187.216 195.452 184.681 193.956L184.641 193.932C182.879 192.892 181.141 191.866 179.36 190.813C176.408 192.769 173.442 194.732 170.481 196.694C164.801 200.454 159.135 204.206 153.595 207.878C159.887 214.354 165.688 220.325 171.993 226.827ZM150.303 290.614C149.874 286.286 149.464 282.121 149.058 278.009L149.052 277.947C148.619 273.557 148.192 269.226 147.755 264.818H139.153C138.804 268.376 138.462 271.887 138.12 275.396L138.119 275.403L138.118 275.417L138.117 275.423C137.628 280.449 137.139 285.47 136.631 290.614H150.303ZM34.3625 90.8926L44.2636 104.425L60.193 99.1901L50.3827 112.788L60.2838 126.32L44.3196 121.192L34.5093 134.79L34.4532 118.023L18.4891 112.895L34.4186 107.66L34.3625 90.8926ZM231.404 149.356L221.503 135.824L221.559 152.592L205.63 157.826L221.594 162.955L221.65 179.722L231.46 166.124L247.424 171.252L237.523 157.72L247.334 144.122L231.404 149.356ZM255.199 98.6367L248.609 108.963L256.394 118.422L244.536 115.345L237.946 125.672L237.208 113.444L225.35 110.368L236.752 105.887L236.013 93.659L243.798 103.118L255.199 98.6367ZM66.5784 165.227L59.9884 175.554L71.3896 171.073L79.1743 180.531L78.4359 168.304L89.8371 163.823L77.9796 160.746L77.2413 148.519L70.6513 158.845L58.7938 155.769L66.5784 165.227Z"
            />
          </svg>
          <div>
            <TextComponent textClass={styles.modalText1}>
              Vendor is Edited
            </TextComponent>
            <TextComponent textClass={styles.modalText2}>
              Successfully!
            </TextComponent>
          </div>
        </Row>
      </Modal>
    </>
  );
}

export default EditVendors;
